// extracted by mini-css-extract-plugin
export default {"noResultsContainer":"NoResults__noResultsContainer--hBJFX","reset":"NoResults__reset--usA49"};